import React from 'react';

import { AppBar as MUIAppBar } from '@mui/material';
import LanguageDropDown from 'components/LanguageDropDown';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
    toolbar: {
        marginLeft: 'auto',
    },
}));

const AppBar = () => {
    const classes = useStyles();
    return (
        <MUIAppBar elevation={0} sx={{ background: 'transparent', zIndex: 100, padding: 2 }}>
            <div className={classes.toolbar}>
                <LanguageDropDown />
            </div>
        </MUIAppBar>
    );
};

AppBar.displayName = 'AppBar';

export default AppBar;
